export const initialData = {
  nivel_autorizacao: '',
  nomeclatura: '',
  obrigatoria: '',
  tipo_user_id: ''
}
export default initialData;